import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class UcpMediaObject extends ApplicationRecord {
  static jsonapiType = "ucp_media_objects";

  @Attr() description: string;

  @Attr() externalId: string;

  @Attr() mediaId: number;

  @Attr() mimeType: string;
}

export default UcpMediaObject;
